import { IconUpload } from '@tabler/icons-react';
import NSIcon from 'bricks/NSIcon/NSIcon';
import React from 'react';
import { Input, Label } from 'reactstrap';
import { IInputProps } from 'react-dropzone-uploader';
import RenderIf from '../../../components/RenderIf/RenderIf';

interface NSDropzoneInputComponentProps extends IInputProps {
    text?: string;
}

const NSDropzoneInputComponent = ({
    accept, onFiles, getFilesFromEvent, content, multiple = true, text = 'Drag & drop files or',
}: NSDropzoneInputComponentProps) => (
    <div className="justify-content-center align-items-center my-3">
        <div className="mb-2 text-center">
            <NSIcon
                icon={IconUpload}
                size="2x"
            />
        </div>

        <div className="text-center">
            <div className="my-1 text-center">
                <span className="text-dark h5">{text}</span>
                <Label className="ml-1 mb-0">
                    <u className="text-primary cursor--pointer h5">Browse</u>
                    <Input
                        style={{ display: 'none' }}
                        type="file"
                        accept={accept}
                        multiple={multiple}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            getFilesFromEvent(event).then((chosenFiles: File[]) => {
                                onFiles(chosenFiles);
                            });
                        }}
                    />
                </Label>
            </div>
            <RenderIf isTrue={typeof content === 'string'}>
                <h6 className="my-0">
                    {content}
                </h6>
            </RenderIf>
        </div>
    </div>
);

export default NSDropzoneInputComponent;
